// extracted by mini-css-extract-plugin
export default {"callout":"Callout_callout__YdqAa"};